var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegister(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 56,
    viewBox: "0 0 62 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.494 7.42859H60.7628V24.5714H56.494V7.42859Z",
    fill: "#6FCF97",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8221 1H50.0909V24.5714H45.8221V1Z",
    fill: "#6FCF97",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1503 11.7143H39.419V24.5714H35.1503V11.7143Z",
    fill: "#6FCF97",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8814 54.5714H26.6126V41.7143C26.611 40.0098 25.9358 38.3757 24.7353 37.1705C23.5349 35.9653 21.9072 35.2874 20.2095 35.2857H11.6719C9.97423 35.2874 8.34655 35.9653 7.14609 37.1705C5.94563 38.3757 5.27047 40.0098 5.26877 41.7143V54.5714H1V41.7143C1.00339 38.8737 2.12884 36.1505 4.12948 34.1419C6.13012 32.1333 8.8426 31.0034 11.6719 31H20.2095C23.0388 31.0034 25.7513 32.1333 27.7519 34.1419C29.7526 36.1505 30.878 38.8737 30.8814 41.7143V54.5714Z",
    fill: "#6FCF97",
    stroke: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9407 9.57143C17.2072 9.57143 18.4452 9.94846 19.4981 10.6548C20.5511 11.3612 21.3719 12.3652 21.8565 13.5399C22.3411 14.7146 22.4679 16.0071 22.2209 17.2542C21.9738 18.5012 21.364 19.6466 20.4685 20.5457C19.573 21.4447 18.432 22.057 17.1899 22.3051C15.9478 22.5531 14.6604 22.4258 13.4904 21.9392C12.3203 21.4527 11.3203 20.6287 10.6167 19.5715C9.91312 18.5144 9.53758 17.2715 9.53758 16C9.53758 14.295 10.2122 12.6599 11.413 11.4543C12.6138 10.2487 14.2425 9.57143 15.9407 9.57143ZM15.9407 5.28572C13.83 5.28572 11.7667 5.9141 10.0117 7.0914C8.25674 8.2687 6.88889 9.94205 6.08116 11.8998C5.27342 13.8576 5.06208 16.0119 5.47386 18.0903C5.88564 20.1686 6.90204 22.0777 8.39454 23.5762C9.88704 25.0746 11.7886 26.095 13.8588 26.5084C15.9289 26.9218 18.0747 26.7097 20.0247 25.8987C21.9748 25.0878 23.6415 23.7145 24.8141 21.9525C25.9868 20.1906 26.6127 18.1191 26.6127 16C26.6127 14.593 26.3366 13.1997 25.8003 11.8998C25.264 10.5999 24.4779 9.41878 23.4869 8.42386C22.496 7.42895 21.3195 6.63974 20.0247 6.1013C18.7299 5.56285 17.3422 5.28572 15.9407 5.28572Z",
    fill: "#6FCF97",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegister);
export default __webpack_public_path__ + "static/media/register.53a5f16318d1c1a13f5516f90e4c0c44.svg";
export { ForwardRef as ReactComponent };